<template>
    <div
        class="c-photo"
        @click="eSelectedPhoto()"
        style="cursor:pointer"
        @drop.prevent="eAddFile"
        @dragover.prevent
    >
        <v-card
            class="rounded-0"
            elevation="0"
            color="transparent"
            width="100%"
            height="100%"
        >
            <v-card
                v-if="withImgDB"
                class="rounded-0"
                elevation="0"
                color="transparent"
                width="100%"
                height="100%"
            >
                <v-img
                    :src="routePhoto"
                    width="100%"
                    height="100%"
                    contain
                ></v-img>
            </v-card>
            <v-card
                v-else
                :class="routePhoto!=''
                    ? 'rounded-0'
                    : 'd-flex justify-center align-center'"
                elevation="0"
                color="transparent"
                width="100%"
                height="100%"
            >
                <v-img
                    v-if="routePhoto!=''"
                    :src="routePhoto"
                    width="100%"
                    height="100%"
                    contain
                ></v-img>
                <div v-else>
                    <h1 class="app-private-title text-center">{{title}}</h1>
                    <h1 class="app-private-subtitle text-center">{{subtitle}}</h1>
                    <h1 class="app-private-subtitle text-center">(Máximo: 3Mb)</h1>
                </div>
            </v-card>
        </v-card>
        <input
            type="file"
            :ref="referenceImg"
            class="d-none"
            accept="image/jpeg"
            @change="eSelectedFile"
        >
    </div>
</template>
<script>
export default {
    props: {
        referenceImg: String,
        title: String,
        subtitle: String,
        withImgDB: Boolean
    },
    data: () => ({
        routePhoto: ""
    }),
    methods: {
        resetData() {
            this.routePhoto = "";
        },
        cargarImg(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.routePhoto = e.target.result;
            }
            reader.readAsDataURL(file);
        },
        eAddFile(e) {
            const files = e.dataTransfer.files;
            if (files[0] !== undefined) {
                let file = e.dataTransfer.files[0];
                if (file.size <= 3145728) {//2097152
                    if (file.type != 'image/jpeg')
                        this.sendValuesPhoto(null, false);
                    else this.sendValuesPhoto(file, true);
                } else this.sendValuesPhoto(null, false);
            } else this.sendValuesPhoto(null, false);
        },
        sendValuesPhoto(file, state) {
            this.otherImgSelected = state;
            const parameters = {
                "file": file,
                "state": state
            };
            this.$emit("changePhoto", parameters);
            if (state) this.cargarImg(file);
            else this.routePhoto = "";
        },
        eSelectedFile(e) {
            const files = e.target.files
            if (files[0] !== undefined) {
                let file = e.target.files[0];
                if (file.size <= 2097152)
                    this.sendValuesPhoto(file, true);
                else this.sendValuesPhoto(null, false);
            } else this.sendValuesPhoto(null, false);
        },
        eSelectedPhoto() {
            this.$refs[this.referenceImg].click();
        }
    }
}
</script>